import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { PageHeader } from './PageHeader';

const sample: Dictionary<{ title: string; add: string; apps: string }> = {
  pl: { title: 'Portfele', add: 'Dodaj portfel', apps: 'Aplikacje' },
  en: { title: 'Wallets', add: 'Add wallet', apps: 'Applications' },
};

export default {
  kind: 'component',
  title: { pl: 'Nagłówek strony', en: 'Page header' },
  description: {
    pl: '`<h1>` strony. Z `actions` dzieli wiersz z przyciskami, odsunięty od nich; `centered` dla strony bez paska bocznego.',
    en: "A page's `<h1>`. With `actions` it shares a row with them, pushed apart; `centered` for a page without a sidebar.",
  },
  variants: [
    {
      name: { pl: 'Sam tytuł', en: 'Title only' },
      render: (locale) => <PageHeader title={sample[locale].title} />,
    },
    {
      name: { pl: 'Z akcjami', en: 'With actions' },
      render: (locale) => (
        <PageHeader
          title={sample[locale].title}
          actions={
            <button type="button" className="btn-primary">
              {sample[locale].add}
            </button>
          }
        />
      ),
    },
    {
      name: { pl: 'Wyśrodkowany', en: 'Centered' },
      render: (locale) => <PageHeader title={sample[locale].apps} centered />,
    },
  ],
} satisfies Story;
